import { toType } from './toType'; // eslint-disable-next-line import/prefer-default-export

export var isDeepObject = function isDeepObject(obj) {
  return toType(obj) === 'Object';
};